export default "__VITE_ASSET__CZ4Z3xHt__"